import { render, staticRenderFns } from "./vitalConfigEnt.vue?vue&type=template&id=6f4372d2&scoped=true&"
import script from "./vitalConfigEnt.vue?vue&type=script&lang=js&"
export * from "./vitalConfigEnt.vue?vue&type=script&lang=js&"
import style0 from "./vitalConfigEnt.vue?vue&type=style&index=0&id=6f4372d2&scoped=true&lang=css&"
import style1 from "./vitalConfigEnt.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4372d2",
  null
  
)

export default component.exports